// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3EG1W","Label":"BuildControl_Label__3nNUG","Less":"BuildControl_Less__3zvPp","More":"BuildControl_More__1AiFy"};